<form [formGroup]="formReference">
    <ng-container *ngIf="settings?.length">
        <div class="settings-section">
            <ng-container formArrayName="{{settingsFormArrayName}}" *ngFor="let x of settings.controls; let i = index">
                <div class="form-settings" *ngIf="showSetting(x)" [formGroupName]="i"
                    [ngClass]="getSettingWidthClass(x)" [ngSwitch]="x.get('settingType')?.value?.toLowerCase()">

                    <mat-form-field class="half-transparent-background lc-form-field" *ngSwitchCase="'string'" appearance="outline">
                        <label>{{x.get('displayName')?.value}}</label>
                        <input matInput formControlName="value" *ngIf="!x.get('isSensitive')?.value" placeholder="">
                        <input matInput formControlName="value" *ngIf="x.get('isSensitive')?.value" [type]="'password'">
                    </mat-form-field>

                    <div *ngSwitchCase="'boolean'" class="checkbox-setting">
                        <label>{{x.get('displayName')?.value}}</label>
                        <mat-slide-toggle formControlName="value" color="primary">{{x.get('value')?.value ? 'Enabled' :
                            'Disabled'}}</mat-slide-toggle>
                    </div>

                    <mat-form-field class="lc-form-field" *ngSwitchCase="'undefined'" appearance="outline">
                        <label>{{x.get('displayName')?.value}}</label>
                        <input matInput formControlName="value" placeholder="">
                    </mat-form-field>

                    <mat-form-field class="lc-form-field" *ngSwitchCase="'b2bformat'" appearance="outline">
                        <label>{{x.get('displayName')?.value}}</label>
                        <mat-select formControlName="value" [compareWith]="compareEnum"
                            (selectionChange)="b2bFormatChanged()" (blur)="b2bFormatChanged()">
                            <mat-option *ngFor="let enumValue of b2BFormatView" [value]="enumValue">{{enumValue}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    
                    <mat-form-field class="lc-form-field" *ngSwitchCase="'icollection`1'" appearance="outline">
                        <label>{{x.get('displayName')?.value}}</label>
                        <mat-select formControlName="value" #select (openedChange)="selectToggled()">
                            <mat-form-field class="form-field inner-mat-input lc-form-field" appearance="outline">
                              <input matInput #selectSearch placeholder="Search..."  />
                            </mat-form-field>
                              <mat-select-trigger>
                                  {{select.value}}
                              </mat-select-trigger>
                              <div class="overflow-list">
                              <div *ngFor="let value of x.get('typeValues')?.value" >
                                <div [hidden]="selectSearch.value.length > 2 && !isInFilter(value)">
                                  <mat-option [value]="getSelectionListValue(value, x)">{{ value }}</mat-option>
                                </div>
                              </div>
                              </div>
                          </mat-select>
                    </mat-form-field>

                    <mat-form-field class="lc-form-field" *ngSwitchDefault appearance="outline">
                        <label>{{x.get('displayName')?.value}}</label>
                        <mat-select formControlName="value" [compareWith]="compareEnum">
                            <mat-option *ngFor="let enumValue of x.get('typeValues')?.value" [value]="enumValue">
                                {{enumValue}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div *ngIf="x.get('moveNextSettingToNewLine')?.value" class="flex-placeholder"></div>
            </ng-container>
        </div>
    </ng-container>
    <ng-container *ngIf="files?.length">
        <div class="settings-files-section">
            <ng-container formArrayName="{{filesFormArrayName}}" *ngFor="let x of files.controls; let i = index">
                <div class="form-file-settings" [formGroupName]="i">
                    <app-plugin-file [isInCustomerConfigurationMode]="isInCustomerConfigurationMode" [file]="x">
                    </app-plugin-file>
                </div>
            </ng-container>
        </div>
    </ng-container>
    <ng-container *ngIf="hasSupportForMappings()">
        <app-mapping-rule-configuration [isInCustomerConfigurationMode]="isInCustomerConfigurationMode">
        </app-mapping-rule-configuration>
    </ng-container>
</form>
